import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import Drawer from '../../../../../components/Drawer/Drawer';
import { reset } from '../../../../../stores/AssignDeviceStore';
import AddDeviceStep from './AddDeviceStep';

interface AddDeviceDrawerProps {
  open: boolean;
  onClose: () => void;
  onAddDeviceSuccess: () => void;
  unassignedReport?: boolean;
}
function AddDeviceDrawer({ open, onClose, onAddDeviceSuccess, unassignedReport }: AddDeviceDrawerProps) {
  const dispatch = useDispatch();

  /**
   * Handle the close action
   */
  const handleClose = () => {
    dispatch(reset());
    onClose();
  };
  const [t] = useTranslation();

  return (
    <Drawer
      disablePortal
      open={open}
      onClose={handleClose}
      onBackButton={handleClose}
      anchor="right"
      title={t('pages.addDeviceDrawer.title')}
      progress={100}
    >
      <Box sx={{ paddingTop: '1rem', height: '100%' }}>
        <AddDeviceStep
          onClose={handleClose}
          onAddDeviceSuccess={onAddDeviceSuccess}
          unassignedReport={unassignedReport}
        />
      </Box>
    </Drawer>
  );
}

export default AddDeviceDrawer;
